import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  itemsSelector,
  deviceByIdSelector,
  labelsForCurrentSiteSelector,
  labelsByDeviceIdSelector,
  isAdminSelector,
  isManagerSelector,
} from '../selectors';
import {
  addLabelToDevice,
  createLabelInCurrentSite,
  updateLabel,
  deleteLabel,
  removeLabelFromDevice,
  hideDevice,
} from '../actions/entry';
import DeviceDetail from '../components/Device/DeviceDetail';

const makeMapStateToProps = (state, { id }) => {
  const items = itemsSelector(state);
  const device = deviceByIdSelector(state, id);
  const allLabels = labelsForCurrentSiteSelector(state);
  const labels = labelsByDeviceIdSelector(state, id);

  const isAdmin = isAdminSelector(state);
  const isManager = isManagerSelector(state);
  const isError = device.status !== 0;

  return {
    isError,
    allLabels,
    labels,
    device,
    items,
    canEdit: isAdmin || isManager,
  };
};

const mapDispatchToProps = (dispatch, { id }) =>
  bindActionCreators(
    {
      onUpdate: () => hideDevice(id),
      onLabelAdd: (labelId) => addLabelToDevice(labelId, id),
      onLabelRemove: (labelId) => removeLabelFromDevice(labelId, id),
      onLabelCreate: createLabelInCurrentSite,
      onLabelUpdate: updateLabel,
      onLabelDelete: deleteLabel,
    },
    dispatch,
  );

export default connect(makeMapStateToProps, mapDispatchToProps)(DeviceDetail);
